import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeatureSection from '../components/home/FeatureSection';
import TestimonialSection from '../components/home/TestimonialSection';
import StatsSection from '../components/home/StatsSection';
import CTASection from '../components/home/CTASection';
import RecommendedCourses from '../components/home/RecommendedCourses';
import RecommendedTeachers from '../components/home/RecommendedTeachers';

const Home = () => {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <RecommendedCourses />
      <RecommendedTeachers />
      <StatsSection />
      <FeatureSection />
      <TestimonialSection />
      <CTASection />
    </div>
  );
};

export default Home;